import {getLocaleContent} from '@helper/locale-content.js';
import Link from 'next/link';
import {useRouter} from 'next/router';
import React, {useContext, useState} from 'react';
import TNHContext from '@contexts/TNHContext';
import {getInternalHref} from '@helper/seo/site';

function Footer({menu = []}) {
    const {email, hotline, facebook, youtube, tiktok, newsCategories, pressTalkTnhId, promotionId, menuFooter} =
        useContext(TNHContext);

    const {locale} = useRouter();

    return (
        <>
            <footer className="site-footer" id="footer">
                <div className="footer__top">
                    <div className="container footer__grid">
                        <div className="footer__brand">
                            <img className="footer__logo" src="/bw_image/logo_m.svg" alt="TNH" />
                            <span className="footer__company">{getLocaleContent(locale, 'common.company')}</span>

                            <div className="footer__info">
                                <a className="footer__link" href={`tel:${hotline}`}>
                                    <span>{getLocaleContent(locale, 'common.consultation')}</span> {hotline}
                                </a>

                                <a className="footer__link" href={`mailto:${email}`}>
                                    <span>{getLocaleContent(locale, 'common.email')}:</span> {email}
                                </a>
                            </div>

                            <div className="footer__socials">
                                {facebook && (
                                    <a href={facebook} aria-label="Facebook" className="sbtn" rel="noopener noreferrer">
                                        <img src="/bw_image/ic_fb.svg" alt="" />
                                    </a>
                                )}
                                {youtube && (
                                    <a href={youtube} aria-label="YouTube" className="sbtn" rel="noopener noreferrer">
                                        <img src="/bw_image/ic_yt.svg" alt="" />
                                    </a>
                                )}
                                {tiktok && (
                                    <a href={tiktok} aria-label="TikTok" className="sbtn" rel="noopener noreferrer">
                                        <img src="/bw_image/ic_tt.svg" alt="" />
                                    </a>
                                )}
                            </div>
                        </div>

                        {/* Dynamically Render Footer Columns */}
                        {menuFooter.map(menuItem => (
                            <div className="footer__col" key={menuItem.web_category_id}>
                                <h4 className="footer__title">
                                    <Link href={getInternalHref(menuItem.url)}>
                                        <a>{menuItem.web_category_name}</a>
                                    </Link>
                                </h4>
                                <ul className="footer__list">
                                    {menuItem.child && menuItem.child.length > 0
                                        ? menuItem.child.map(childItem => (
                                              <li key={childItem.web_category_id}>
                                                  <Link href={getInternalHref(childItem.url)}>
                                                      <a>
                                                          <img
                                                              className="bullet"
                                                              src="/bw_image/ic_chevron_right.svg"
                                                              alt=""
                                                          />
                                                          {childItem.web_category_name}
                                                      </a>
                                                  </Link>
                                              </li>
                                          ))
                                        : null}
                                </ul>
                            </div>
                        ))}

                        <div className="footer__col">
                            <h4 className="footer__title">
                                <Link href="/tin-tuc">
                                    <a>{getLocaleContent(locale, 'common.news')}</a>
                                </Link>
                            </h4>
                            <ul className="footer__list">
                                {newsCategories.map(category => (
                                    <li key={category.news_category_id}>
                                        <Link
                                            href={{
                                                pathname: '/tin-tuc',
                                                query: {news_category_id: category.news_category_id},
                                            }}>
                                            <a>
                                                <img className="bullet" src="/bw_image/ic_chevron_right.svg" alt="" />
                                                {category.news_category_name}
                                            </a>
                                        </Link>
                                    </li>
                                ))}
                                <li>
                                    <Link
                                        href={{
                                            pathname: '/quan-he-co-dong',
                                        }}>
                                        <a>
                                            <img className="bullet" src="/bw_image/ic_chevron_right.svg" alt="" />
                                            {getLocaleContent(locale, 'common.shareholder-relations')}
                                        </a>
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="footer__app">
                            <h4 className="footer__title">{getLocaleContent(locale, 'common.download')}</h4>
                            <img className="footer__qr" src="/bw_image/qr_app.svg" alt="QR tải app" />
                            <div className="footer__badges">
                                <img src="/bw_image/badge_dmca.svg" alt="DMCA Protected" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer__bottom">
                    <div className="container footer__bottom__row">
                        <div className="footer__copy">Copyright ©{new Date().getFullYear()}. All Rights Reserved</div>
                        <div className="footer__credit">Design by TNH</div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default React.memo(Footer);
